import React, { useEffect } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface SuccessNotificationProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
}
export const SuccessNotification: React.FC<SuccessNotificationProps> = ({
  message,
  isVisible,
  onClose
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-bounce-in" data-id="element-3609">
      <div className="bg-white border-l-4 border-green-500 shadow-lg rounded-md p-4 flex items-start max-w-sm" data-id="element-3610">
        <CheckCircleIcon className="text-green-500 mr-3 flex-shrink-0" size={24} data-id="element-3611" />
        <div className="flex-grow mr-2" data-id="element-3612">
          <h3 className="font-bold text-gray-800 text-sm" data-id="element-3613">Berhasil!</h3>
          <p className="text-gray-600 text-sm" data-id="element-3614">{message}</p>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-3615">
          <XIcon size={16} data-id="element-3616" />
        </button>
      </div>
    </div>;
};